export default __webpack_public_path__ + "static/media/light-play.bb260620.svg";